$(function() {
    // $(".selectpicker").selectpicker();

    $('.form-check-input[type="checkbox"]').on("change", function() {
        var $this = $(this);
        if ($this.prop("checked")) {
            $this.parent().addClass("checked");
        } else {
            $this.parent().removeClass("checked");
        }
    });
    $('.form-check-input[type="radio"]').on("change", function() {
        var $this = $(this);
        $this
            .parent()
            .parent()
            .parent()
            .find(".form-check-label")
            .removeClass("checked");
        if ($this.prop("checked")) {
            $this.parent().addClass("checked");
        }
    });
});

$(window).on("load", function() {
    $('.form-check-input[type="checkbox"]').each(function() {
        var $this = $(this);
        if ($this.prop("checked")) {
            $this.parent().addClass("checked");
        } else {
            $this.parent().removeClass("checked");
        }
    });
    $('.form-check-input[type="radio"]').each(function() {
        var $this = $(this);
        if ($this.prop("checked")) {
            $this.parent().addClass("checked");
        } else {
            $this.parent().removeClass("checked");
        }
    });
});
